module.exports = __webpack_public_path__ + "img/logo-um-ff-ang.c44bb0e6.png";